import {getTokenKey} from 'helpers/localStorage'
import _ from 'lodash'
import {useCallback} from 'react'
import {useHistory} from "../../modules/navigation/useRouter";

export const useRequiredLogin = callback => {
  const history = useHistory()
  const handler = useCallback(
    cb => {
      const tokenKey = getTokenKey();
      const isInvalidToken =
          tokenKey == undefined ||
          tokenKey == null ||
          tokenKey === 'null' ||
          tokenKey === 'undefined' ||
          tokenKey === '';
      if (isInvalidToken) {
        history.push({
          pathname: '/login',
          state: {
            isModal: true
          }
        })
      } else {
        _.isFunction(callback) &&
          callback()
        _.isFunction(cb) && cb()
      }
    },
    [callback, history]
  )
  return handler
}
